export const APPROVED_PROCEDURE_CATEGORIES = [
  "Cosmetic",
  "Diagnostic",
  "Emergency",
  "Endodontic",
  "Follow-up",
  "Implant",
  "Oral Surgery",
  "Orthodontic",
  "Pediatric",
  "Periodontal",
  "Preventive",
  "Prosthodontic",
  "Restorative",
];

export function isApprovedProcedureCategory(category) {
  return APPROVED_PROCEDURE_CATEGORIES.includes(String(category || "").trim());
}
